module.exports = __webpack_public_path__ + "static/tangled-2_ceramic-mixed-media-7x4in-f8c003a93ed61f0f25763774293c52e4.jpg";